import { MessageReference } from 'types/Api'

export function isAiGeneratedSummary(reference: MessageReference) {
  if (reference.sourceType !== 'karnov_document') {
    return false
  }
  return !!reference.metadata?.aiGenerated
}
